export class TjenesteType {
  static TekniskTjeneste = -1;
  static IkkeInnloggetTjeneste = 0;
  static Timeavtaler = 1;
  static Fastlegetjenester = 6;
  static Legemidler = 7;
  static PersonligHelsearkiv = 8;
  static Fastlegevisning = 9;
  static InnsynPasientjournal = 10;
  static InnsynKjernejournal = 11;
  static Egenandeler = 12;
  static Profil = 13;
  static MinHelseForside = 15;
  static EksterneTjenester = 16;
  static Henvisninger = 17;
  static Pasientreiser = 18;
  static Forlopskoordinator = 19;
  static Meldinger = 20;
  static ByttFastlege = 21;
  static DialogForlop = 22;
  static DialogHelsehjelp = 23;
  static Fullmaktsadministrasjon = 24;
  static Helsekontakter = 25;
  static DialogOkonomi = 26;
  static Beslutningsstotte = 27;
  static DialogInnsyn = 28;
  static DialogPersonvern = 29;
  static Helseregistre = 30;
  static LoggOverBrukAvResepter = 31;
  static SykdomOgKritiskInformasjon = 32;
  static Forskning = 33;
  static MinHelse = 34;
  static Timeadministrasjon = 35;
  static Foreldresamtykke = 36;
  static DialogEgenHelseUngdom = 37;
  static KprTjenester = 38;
  static Vaksiner = 39;
  static LegemidlerLiB = 40;
  static InnsynRegisterinnhold = 41;
  static InnsynRegisterbruk = 42;
  static EKonsultasjon = 43;
  static Reseptfornyelse = 44;
  static EKontakt = 45;
  static Timebestilling = 46;
  static KritiskInfo = 47;
  static AapneKjernejournal = 48;
  static ProfildataOgKjernejournal = 49;
  static HelsekontakterIKjernejournal = 50;
  static LegemidlerFraKjernejournal = 51;
  static ProfildataOgKjernejournalReservasjon = 52;
  static PersonopplysningerFraKjernejournal = 53;
  static Donorkort = 54;
  static Samtykkeforesporsel = 55;
  static DialogForlopInformasjon = 56;
  static Pasientreiseradministrasjon = 57;
  static NyttHelsenorgeSamtykke = 58;
  static InngripendeForPersonvern = 59;
  static Skjemautfyller = 60;
  static SamvalgUtenLagring = 61;
  static MeldeFeilIBesokshistorikkKj = 62;
  static Verktoy = 63;
  static VerktoyUtforelse = 64;
  static InnsynRegisterinnholdReseptformidler = 65;
}

export enum StatusType {
  UnderArbeid = 1,
  Publisert = 2,
  ErstattetAvNyereVersjon = 3,
  TrukketTilbake = 4,
}

export enum BehandlerInnsynType {
  Ingen = 1,
  Krever = 2,
  TilbysIVerktoy = 3,
}

export enum OppstartType {
  Ingen = 1,
  DirekteUrl = 2,
  Skjema = 3,
  LTIv1_1 = 4,
  OIDC = 5,
}

export enum VerktoyKategori {
  IngenBrukerprofil = 1,
  LokalBrukerprofil = 2,
  EgenBrukerprofil = 3,
  SentralBrukerprofil = 4,
  SentralPseudonymisertBrukerprofil = 5,
}

export enum LaeringsaktivitetStatusType {
  Unknown = 0,
  Enrolled = 1,
  Started = 2,
  Completed = 3,
}

export enum OpprettetAvType {
  Unknown = 0,
  ProfilGuid = 1,
  Organization = 2,
  Hpr = 3,
  PseudoId = 4,
  Foedselnummer = 5,
}

export enum VerktoyFormal {
  Informasjon = 1,
  Laring = 2,
  Veiledning = 3,
  Behandling = 4,
  Kartlegging = 5,
  Sjekkpunkt = 6,
  Kontrollsporsmal = 7,
}

export enum FagomradeType {
  PSYKISK_HELSE = 1,
  SYKDOM_OG_SKADER = 2,
  LIVSSTIL_OG_TRENING = 3,
  TANKER_OG_FOLELSER = 4,
  GRAVIDITET_OG_FODSEL = 5,
  RAAD_OG_TIPS_I_HVERDAGEN = 6,
}

export enum Innholdstype {
  Informasjon = 1,
  Video = 2,
  Podkast = 3,
  Oppgaver = 4,
  Spill = 5,
  Chat = 6,
  Forum = 7,
  Egenregistreringer = 8,
  Maaleverktoy = 9,
  AnbefalningerOgRaad = 10,
}

export enum MalgruppeType {
  Barn = 1,
  Ungdom = 2,
  Voksne = 3,
  Eldre = 4,
}

export enum SprakType {
  NorskBokmal = 1,
  NorskNynorsk = 2,
  Engelsk = 3,
}

export enum GrafiskElementType {
  Ikon = 1,
  Bilde = 2,
}

export enum LenkeType {
  Standard = 1,
  NedlastingAppAndroid = 2,
  NedlastingAppIphone = 3,
  Utvidetinformasjon = 4,
}

export interface Verktoy {
  VerktoyId: string;
  Navn: string;
  Ingress: string;
  Beskrivelse: string;
  StatusType: StatusType;
  VerktoyFormal: VerktoyFormal;
  FagligAnsvarlig: string;
  UtvikletAv: string;
  SprakTyper: Array<SprakType>;
  OppstartType: OppstartType;
  VerktoyKategori: VerktoyKategori;
  InterntVerktoy: boolean;
  Fagomrader: Array<FagomradeType>;
  Malgrupper: Array<MalgruppeType>;
  GrafiskeElementer: Array<GraphicalElement>;
  Laeringsressurs: Laeringsressurs;
  Laeringsaktivitet?: Laeringsaktivitet;
  OpprettetDato: string;
  EndretDato: string;
  PublisertDato: string;
  HovedType: HovedType;
  KanUtforesRepresentasjon: boolean;
  KanStartesAvInnloggetBruker: boolean;
  HarBegrensetTilgang: boolean;
  Lenker: Array<Lenke>;
  GyldigFraDato?: string;
  GyldigTilDato?: string;
  VisSprak: boolean;
}

export interface Laeringsressurs {
  Url: string;
  AntattTid: number;
  VerktoyTyper: Array<VerktoyType>;
  Innholdstyper: Array<Innholdstype>;
  BehandlerInnsynType: BehandlerInnsynType;
  KreverForskrivning: boolean;
  DataansvarligNavn: string;
}

export interface Lenke {
  LenkeType: LenkeType;
  Url: string;
}

export interface Laeringsaktivitet {
  LaeringsaktivitetId: number;
  OpprettetAvTypeId: OpprettetAvType;
  OpprettetAvNavn: string;
  Opprettet: string;
  Status: LaeringsaktivitetStatusType;
  Hensikt?: string;
  Begrunnelse?: string;
}

export interface GraphicalElement {
  Id: number;
  TypeId: GrafiskElementType;
  B64Content: string;
  MimeType: string;
  AlternativTekst: string;
}

export enum HovedType {
  Veiledningstjeneste = 1,
  Laeringsressurs = 2,
  Skjema = 3,
  Triagering = 4,
}

export enum VerktoyType {
  App = 1,
  Weblosning = 2,
}

export enum SorteringType {
  Standard = 0,
  PublisertDato = 1,
  VerktoyNavn = 2,
}

/*** Interface for et oppsett for hvordan query parameter verdiene skal mappes til korrekte enum verdier */
export interface QueryMapSetup {
  value: string;
  name: string;
  displayname: string;
}

export enum LagtTilAvType {
  InnbyggerSelv = 1,
  Representant = 2,
  Behandler = 3,
}

export interface MittVerktoyItem {
  LaeringsaktivitetId: number;
  VerktoyId: string; // UUID string
  VerktoyNavn: string;
  Begrunnelse: string | null;
  LagtTilDato: string | null;
  LagtTilAv: string | null;
  LagtTilAvTypeId: number | null;
  Lenker: Lenke[];
  KreverForskrivning: boolean;
  VerktoyType: number[];
  OppstartType: number;
  KanStartesAvInnloggetBruker: boolean;
  GrafiskElementId: number | null;
  ErVerktoyTilgjengelig: boolean | null;
  LaeringsaktivitetGuid: string;
  InterntVerktoy: boolean;
}

export interface LaeringsaktivitetV2 {
  LaeringsaktivitetId: number;
  VerktoyId: string;
  VerktoyNavn: string;
  Begrunnelse: string | null;
  LagtTilDato: string | null;
  LagtTilAv: string | null;
  LagtTilAvTypeId: number | null;
  Lenker: Lenke[];
  KreverForskrivning: boolean;
  VerktoyType: number[];
  OppstartType: number;
  KanStartesAvInnloggetBruker: boolean;
  GrafiskElementId: number | null;
  ErVerktoyTilgjengelig: boolean | null;
  LaeringsaktivitetGuid: string;
  InterntVerktoy: boolean;
}

export interface LaeringsaktivitetV2Response {
  LaeringsaktivitetV2: LaeringsaktivitetV2;
}
